import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonWrapper = styled.div({
	display: 'flex',
	height: '39px',
	marginBottom: token('space.150'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Avatar = styled.div({
	background: token('color.background.neutral'),
	height: '32px',
	width: '32px',
	margin: token('space.025'),
	marginRight: token('space.150'),
	borderRadius: token('radius.full'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Action = styled.div({
	background: token('color.background.neutral'),
	width: '168px',
	marginBottom: token('space.075'),
	height: '14px',
	borderRadius: token('radius.full'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Time = styled.div({
	background: token('color.background.neutral'),
	width: '85px',
	height: '11px',
	borderRadius: token('radius.full'),
});

export const ActivityLineUpdateDetailSkeleton = () => (
	<SkeletonWrapper data-testid="activity-detail-skeleton">
		<Avatar />
		<div>
			<Action />
			<Time />
		</div>
	</SkeletonWrapper>
);
